import { WTextfield } from '@alice-health/wonderland-react'
import { FunctionComponent } from 'react'
import { useFormContext } from 'react-hook-form'

interface ResponsibleEmailFieldProps {
  placeholder?: string
}

const ResponsibleEmailField: FunctionComponent<ResponsibleEmailFieldProps> = ({
  placeholder = 'E-mail de contato'
}) => {
  const {
    register,
    setValue,
    clearErrors,
    trigger,
    formState: { errors }
  } = useFormContext<{
    responsibleEmail: string
  }>()

  return (
    <>
      {/* Email Name field cannot be changed because of Google Ads Conversion */}
      <WTextfield
        {...register('responsibleEmail')}
        name='email'
        placeholder={placeholder}
        invalid={!!errors.responsibleEmail}
        errorText={errors.responsibleEmail?.message}
        onWChange={ev => setValue('responsibleEmail', ev.detail)}
        onInput={() => clearErrors('responsibleEmail')}
        onBlur={() => trigger('responsibleEmail')}
      />
    </>
  )
}

export { ResponsibleEmailField }
